import { makeAutoObservable } from "mobx"
import { Question, QuestionProps } from "./Question"
import { PossibleAnswer } from "./PossibleAnswer"

export interface GivenAnswerProps {
  id?: number
  singleChoiceAnswerId?: number
  multiChoiceAnswerIds?: number[]
  textAnswer?: string
  question?: QuestionProps
  file?: string
}

export class GivenAnswer {
  id?: number
  singleChoiceAnswerId?: number
  multiChoiceAnswerIds?: number[]
  textAnswer?: string
  question?: Question
  file?: string

  constructor(props: GivenAnswerProps) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.singleChoiceAnswerId = props.singleChoiceAnswerId
    this.multiChoiceAnswerIds = props.multiChoiceAnswerIds || []
    this.textAnswer = props.textAnswer || ""
    this.question = props.question && new Question(props.question)
    this.file = props.file
  }

  get hasBeenAnswered(): boolean {
    return this.question?.optional || this.hasAnswer()
  }

  hasAnswer() {
    switch (this.question?.type) {
      case "single_choice":
        return this.singleChoiceAnswerId !== undefined
      case "multi_choice":
        return this.multiChoiceAnswerIds.length > 0
      case "text_field":
        return this.textAnswer.length > 0
      case "text_area":
        return this.textAnswer.length > 0
      case "file_upload":
        return this.file !== undefined
      default:
        return false
    }
  }

  fileUploadLabel() {
    if (this.file !== undefined) {
      return "A file has been uploaded. You can replace it below if you need to."
    }
  }

  chooseAnswer(possibleAnswer: PossibleAnswer) {
    this.singleChoiceAnswerId = possibleAnswer.id
  }

  toggleMultiChoiceAnswer(possibleAnswer: PossibleAnswer) {
    let index = this.multiChoiceAnswerIds.indexOf(possibleAnswer.id)
    if (index === -1) {
      this.multiChoiceAnswerIds.unshift(possibleAnswer.id)
    } else {
      this.multiChoiceAnswerIds.splice(index, 1)
    }
  }
}
